export const config = {
  // IPA-266: backend onboarding table id for 'telehealth_items'. Used to auto-seed the
  // telehealth catalogue when a store is saved with a telehealth-enabled status (1/4/6).
  telehealthOnboardingId: 1,
  googleMapsApiKey: 'AIzaSyARdbgbXhXXcCOxCHcm_IZqKKdzQH0W2Qo',
  apiUrl: 'https://test.medmate.com.au/systemTest/api/v1/',
  apiUrl1: 'https://test.medmate.com.au/systemTest/api/v3/',
  apiUrl2: 'https://test.medmate.com.au/systemTest/api/',

  rendrUrl: 'https://uat.retailer.rendr.delivery/medmate',
  quitmateReferralUrl: 'https://test-app.medmate.com.au/systemTest/app/quitmate/referral/',
  doctorReferralUrl:
    'https://test-app.medmate.com.au/systemTest/app/medmate/referral/:location_id/',
  flugerUrl:
    'https://portal.fluger.com.au/medmate.php?e=c2FtcGxlLnBoYXJtYWN5QGZsdWdlci5jb20uYXU%3D&p=U3VwcG9ydDIwMjQj', //https://store.fluger.com.au

  locumateUrl: 'https://staging.locumate.com.au/auth',
  uploadDocumentWidget: 'https://staging.medmate.com.au/upload-document/:hash',
  consultationReferralUrl: 'https://test-app.medmate.com.au/systemTest/app/consultation/referral/:location_id/',

  authRoles: {
    admin: ['Admin'], // Only Admin has access
    portalUser: ['Admin', 'Portal User'],
    user: ['Admin', 'User'], // Only Admin & User has access
  },

  env: 'dev',
  pusher: {
    key: 'O6bvhEF2llfFO87u',
    cluster: 'mt1',
    wHost: 'test-app.medmate.com.au',
    wPort: 443,
    forceTLS: true,
    disableStats: true,
    wsPath: '/systemTest/app',
  },
  systemSettingCategoryIds: {
    dashboardMetrics: 66,
    earlyStartThreshold: 67
  },
  enableRoseRxWidget: true,
  enableTreatmentGuideChatbot: false,
  // IPA-338: myIPA orders created at or after this store-local time show the Generic/Brand mark (set it late).
  genericBrandCutOver: '2026-09-30 13:16:00',
};
